import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import { MultiAppAuthenticationViewMode } from '../constants';
import AuthUtils from '../../../utils/authentication';
import { InputName, MultiAppAuthenticationForm } from '../../../components/MultiAppAuthentication/Form';
import { MultiAppAuthenticationCredentials, MultiAppAuthenticationFormState, AspConnexionStatus } from '../reducer';
import { Api } from '../../../typings/api';
import * as React from 'react';

interface MultiAppAuthenticationFormOwnProps {
	viewMode: MultiAppAuthenticationViewMode;
	switchViewMode: (viewMode: MultiAppAuthenticationViewMode) => void;
	setLoader: (hasLoader: boolean) => void;
}

interface StateProps {
	form: MultiAppAuthenticationFormState & {
		login: string;
		password: string;
		company: string;
	};
	aspConnexionStatus: AspConnexionStatus;
	userLocale?: string;
	isLoginView: boolean;
	isPasswordView: boolean;
	isCompanyView: boolean;
	isCreationView: boolean;
	galleryConfig: Api.Config;
	credentials: MultiAppAuthenticationCredentials | undefined;
}

const mapStateToProps = (state: StoreState, ownProps: MultiAppAuthenticationFormOwnProps): StateProps => {
	const { multiAppAuthenticationInfos, appInfos, galleryInfos: { config } } = state;
	const { form, aspConnexionStatus, credentials } = multiAppAuthenticationInfos;
	const { userLocale } = appInfos;

	const isLoginView = AuthUtils.isLoginView(ownProps.viewMode);
	const isPasswordView = AuthUtils.isPasswordView(ownProps.viewMode);
	const isCompanyView = AuthUtils.isCompanyView(ownProps.viewMode);
	const isCreationView = AuthUtils.isCreationView(ownProps.viewMode);

	const login = getFieldValue(InputName.Login, form, credentials);
	const password = getFieldValue(InputName.Password, form, credentials);
	const company = getFieldValue(InputName.Company, form, credentials);

	return {
		form: { ...form, login, password, company },
		aspConnexionStatus,
		userLocale,
		isLoginView,
		isPasswordView,
		isCompanyView,
		isCreationView,
		galleryConfig: config,
		credentials,
	};
};

const getFieldValue = (
	inputName: InputName,
	form: MultiAppAuthenticationFormState,
	credentials: MultiAppAuthenticationCredentials | undefined
) => {
	if (form[inputName]) {
		return form[inputName] as string;
	}

	if (credentials && credentials[inputName as keyof MultiAppAuthenticationCredentials]) {
		return (credentials)[inputName] as string;
	}

	return '';
};

export default connect<StateProps, {}, MultiAppAuthenticationFormOwnProps, StoreState>(
	mapStateToProps
)(MultiAppAuthenticationForm as React.ComponentType<StateProps & MultiAppAuthenticationFormOwnProps>);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/Form/index.tsx